import { useMutation } from '@tanstack/react-query'

import api from '@/lib/api'
import { useAccessToken } from '@/features/auth/state/auth'

interface CheckOwnerResponse {
  exists: boolean
  message: string
  statusCode: number
}

export function useCheckOwnerByCpf() {
  const token = useAccessToken()

  return useMutation({
    mutationFn: async (cpf: string): Promise<CheckOwnerResponse> => {
      const response = await api.get(`/owner/cpf-owner-tenant/${cpf}`, {
        headers: { Authorization: `Bearer ${token}` }
      })

      return response.data
    }
  })
}
